import React from 'react';
import Button from '../Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { styled } from '@material-ui/core/styles';

import ListItemText from '@material-ui/core/ListItemText';
import { Flex } from '../Layouts';
import colors from '../../theme/colors';

const List = styled('ul')(() => ({
  paddingLeft: 20,
}));

const ListItem = styled('li')(() => ({}));

const Subject = styled(Typography)(() => ({
  fontSize: 17,
  color: colors.grayShades[0],
  fontFamily: '"Urbanist"',
  fontWeight: 500,
  marginBottom: 20,
}));

const Text = styled(Typography)(({ mb, isBold }) => ({
  marginBottom: mb,
  fontWeight: isBold ? 600 : 500,
  fontFamily: '"Urbanist"',
}));

const Modal = ({ template, open, onClose }) => {
  const { title, subject, contentTitle, content } = template;
  return (
    <Dialog onClose={onClose} open={open}>
      {title && (
        <Flex style={{ justifyContent: 'space-between' }}>
          <DialogTitle style={{ textTransform: 'uppercase' }}>
            <strong>{title}</strong>
          </DialogTitle>
          <IconButton aria-label="close" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Flex>
      )}
      <DialogContent dividers>
        {subject && <Subject>{subject}</Subject>}
        {contentTitle && (
          <Text gutterBottom mb={20} isBold={true}>
            {contentTitle}
          </Text>
        )}
        {content &&
          content.length > 0 &&
          content.map((item) => (
            <React.Fragment key={item.text}>
              <Text
                gutterBottom
                mb={item.list ? 5 : item.subText ? -4 : 15}
                dangerouslySetInnerHTML={{ __html: item.text }}
              />
              {item.subText && <Text>{item.subText}</Text>}
              {item.link && (
                <Text>
                  <a href={item.link} target={'_blank'}>
                    {item.link}
                  </a>
                </Text>
              )}
              {item.list && item.list.length > 0 && (
                <List>
                  {item.list.map((listItem) => (
                    <ListItem key={listItem}>
                      <ListItemText>{listItem}</ListItemText>
                    </ListItem>
                  ))}
                </List>
              )}
            </React.Fragment>
          ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="text">
          Got it!
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default Modal;
